import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LazyElementsModule } from '@angular-extensions/elements';
import { CoverageComponent } from './components/coverage.component';
import { CoverageHomeComponent } from './components/coverage-home/coverage-home.component';
import { CoverageMobileComponent } from './components/coverage-mobile/coverage-mobile.component';
import { CoverageDocsModalComponent } from './components/coverage-docs-modal/coverage-docs-modal-component/coverage-docs-modal-component.component';


@NgModule({
  declarations: [
    CoverageComponent,
    CoverageHomeComponent,
    CoverageMobileComponent,
    CoverageDocsModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LazyElementsModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class CoverageModule { }
